import { Button, Input } from '@sainsburys-tech/fable'
import { Add, Minus } from '@sainsburys-tech/icons'
import React, { useEffect, useState } from 'react'

import { selectCurrentTarget } from '../../../utils/selectCurrentTarget'
import IMixSku from '../../types/IMixSku'

interface IProps {
  mixSku: IMixSku
  setActualProduction: (
    mixSkuId: number,
    isIncrement: boolean,
    productionActual?: number,
  ) => void
}

const MixSkusIncrementor = (props: IProps) => {
  const { mixSku } = props

  const [draft, setDraft] = useState(mixSku.productionActual.toString())

  useEffect(() => {
    setDraft(mixSku.productionActual.toString())
  }, [mixSku.productionActual])

  const isMinusDisabled = (productionActual: number) => productionActual === 0
  const isPlusDisabled = (productionActual: number) => productionActual >= 999

  const handleChange = (value: string) => {
    if (value === '' || /^\d{0,3}$/.test(value)) {
      setDraft(value)
    }
  }

  const commit = () => {
    const finalVal = draft === '' ? 0 : parseInt(draft, 10)
    if (!isNaN(finalVal) && finalVal !== mixSku.productionActual) {
      props.setActualProduction(mixSku.mixSkuId, false, finalVal)
    }
    setDraft(finalVal.toString())
  }

  const applyStep = (isIncrement: boolean) => {
    if (isIncrement) {
      props.setActualProduction(mixSku.mixSkuId, true)
    } else {
      props.setActualProduction(mixSku.mixSkuId, false)
    }
  }

  return (
    <div className='c-common-incrementor'>
      <div className='c-common-incrementor__button'>
        <Button
          isFullWidth={false}
          aria-label='Decrement actual production'
          disabled={isMinusDisabled(mixSku.productionActual)}
          onClick={() => applyStep(false)}
          icon={<Minus />}
          variant='secondary'
          style={{ backgroundColor: 'white' }}
          testid='mix-minus-button'
        />
      </div>
      <div className='c-common-incrementor__input-text-box'>
        <Input
          label='Quantity'
          hasHiddenLabel
          name='actualProductionInput'
          autocomplete='off'
          onFocus={selectCurrentTarget}
          onBlur={commit}
          type='text'
          inputMode='numeric'
          pattern='[0-9]*'
          onChange={handleChange}
          value={draft}
          testid='mix-input'
        />
      </div>
      <div className='c-common-incrementor__button'>
        <Button
          isFullWidth={false}
          aria-label='Increment actual production'
          disabled={isPlusDisabled(mixSku.productionActual)}
          onClick={() => applyStep(true)}
          icon={<Add />}
          variant='secondary'
          style={{ backgroundColor: 'white' }}
          testid='mix-plus-button'
        />
      </div>
    </div>
  )
}

export default MixSkusIncrementor
